var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstanceAuthX360 } from "../RequestAxios/RequestAxiosAuthX360";
var authXApiKeyBaseUrl = function () { return "/api_keys"; };
var authXDeleteApiKeyUrl = function (id) { return "".concat(authXApiKeyBaseUrl(), "/").concat(id); };
export var getApiKeys = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceAuthX360.buffedInstances.get(authXApiKeyBaseUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var generateApiKey = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceAuthX360.buffedInstances.post(authXApiKeyBaseUrl(), payload)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var deleteApiKey = function (_a) {
    var id = _a.id;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstanceAuthX360.buffedInstances.delete(authXDeleteApiKeyUrl(id))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aFguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhdXRoWC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFFQSxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxzQ0FBc0MsQ0FBQztBQUUxRSxJQUFNLGtCQUFrQixHQUFHLGNBQU0sT0FBQSxXQUFXLEVBQVgsQ0FBVyxDQUFDO0FBQzdDLElBQU0sb0JBQW9CLEdBQUcsVUFBQyxFQUFVLElBQUssT0FBQSxVQUFHLGtCQUFrQixFQUFFLGNBQUksRUFBRSxDQUFFLEVBQS9CLENBQStCLENBQUM7QUFFN0UsTUFBTSxDQUFDLElBQU0sVUFBVSxHQUFHLCtDQUFVLE9BQU87Ozs7b0JBQ3hCLHFCQUFNLGtCQUFrQixDQUFDLGVBQWUsQ0FBQyxHQUFHLENBRTNELGtCQUFrQixFQUFFLENBQUMsRUFBQTs7Z0JBRmYsSUFBSSxHQUFLLENBQUEsU0FFTSxDQUFBLEtBRlg7Z0JBSVosc0JBQU8sSUFBSSxFQUFDOzs7S0FDYixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sY0FBYyxHQUFHLFVBQU8sT0FHcEM7Ozs7b0JBRUcscUJBQU0sa0JBQWtCLENBQUMsZUFBZSxDQUFDLElBQUksQ0FDM0Msa0JBQWtCLEVBQUUsRUFDcEIsT0FBTyxDQUNSLEVBQUE7O2dCQUpLLElBQUksR0FDVixDQUFBLFNBR0MsQ0FBQSxLQUpTO2dCQUtaLHNCQUFPLElBQUksRUFBQzs7O0tBQ2IsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLFlBQVksR0FBRyxVQUFPLEVBSWxDO1FBSEMsRUFBRSxRQUFBO3FDQUdBLE9BQU87Ozs7d0JBQ1EscUJBQU0sa0JBQWtCLENBQUMsZUFBZSxDQUFDLE1BQU0sQ0FDOUQsb0JBQW9CLENBQUMsRUFBRSxDQUFDLENBQ3pCLEVBQUE7O29CQUZPLElBQUksR0FBSyxDQUFBLFNBRWhCLENBQUEsS0FGVztvQkFHWixzQkFBTyxJQUFtQyxFQUFDOzs7O0NBQzVDLENBQUMifQ==